import { BaseContainer } from './BaseContainer';
import { MarketingIcon } from 'foundations-assets/icons/components/MarketingIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const CampaignSvg = () => {
  return /*#__PURE__*/_jsx(BaseContainer, {
    $svgSize: '60%',
    children: /*#__PURE__*/_jsx(MarketingIcon, {})
  });
};